
<template>
  <div class="antiInfo">
    <div class="aImg" v-for="(item, index) in list" :key="index">
      
        <img src="../assets/images/撕毁防伪.png" alt="" style="max-width: 100%; max-height: 100%;" v-if="item.msgItems[0].op.op.chinStatus">
        <img src="../assets/images/防伪.png" alt="" style="max-width: 100%; max-height: 100%;" v-else>
      
      <!-- 防伪信息 -->
      <div class="info" @click="hInfo(item)">
        <span class="wen">查看防伪溯源记录</span>
        <span class="tu"><img src="../assets/images/箭头.png" alt="" class="img"></span>
      </div>
      <!-- 线 -->
      <div class="line" :style="{ borderColor : item.msgItems[0].op.op.chinStatus ? '#FA5151' : '#26907A;'}">
      </div>
      <!-- 状态 -->
      <div class="state">
        <div class="bgImg" v-if="item.msgItems[0].op.op.chinStatus">
          <img src="../assets/images/组 23165.png" alt="" style="max-width: 100%; max-height: 100%;">
        </div>
        <div class="bgImg" v-else>
          <img src="../assets/images/完好框.png" alt="" style="max-width: 100%; max-height: 100%;">
        </div>
        <div class="title" :style="{ color: item.msgItems[0].op.op.chinStatus ? '#FA5151' : '#26907A;'}">
          芯片状态
        </div>
        <div class="title2" :style="{ color: item.msgItems[0].op.op.chinStatus ? '#FA5151' : '#26907A;'}">
          {{ item.msgItems[0].op.op.chinStatus ? '撕毁' : '完好' }}
        </div>
      </div>
      <div class="line2">

      </div>
      <!-- 区块链标识： -->
      <!-- <div class="goods-characteristic">
                <div class="goods-characteristic-inner" :style="{ borderColor: item.msgItems[0].op.op.chinStatus ? '#9DA5B2' : '#347B6C'}">
                  <span @click="toBlockChain(item)" :style="{ color: item.msgItems[0].op.op.chinStatus ? '#9DA5B2' : '#347B6C'}">
                    区块链标识：{{ item.msgItems[0].txid }}</span>
               </div>
             </div> -->
           <div class="n-info">
            <div class="num">
            当前验证次数 <div class="n-text">{{ item.msgItems[0].op.op.polled_num }}</div>
           </div>
           <div class="createdDate">
            首次访问时间 <div class="n-text">{{ item.msgItems.at(-1).ts | formant}}</div>
           </div>
           <div class="newDate">
            当前访问时间 <div class="n-text">{{ item.msgItems[0].ts | formant}}</div>
           </div>
           </div>
        </div>
        </div>
</template>

<script>

import Vue from "vue";
import { Popup, Toast } from "vant";
import { Image as VanImage } from 'vant';
Vue.use(Popup);
Vue.use(Toast);
Vue.use(VanImage);
export default {
  props: {
    info: String,
  },
  data () {
    return {
      listDataAll: [],
      list: [],
      list2: null
    }
  },
  created() {
    this.listDataAll = JSON.parse(
      window.localStorage.getItem("slierBarListContent")
    );
    this.list = this.listDataAll.filter(item => item.trace_name === '防伪信息')
    console.log('fffffffffffff', this.list);
    this.list2 = JSON.parse(
      window.localStorage.getItem("reData"))
  },
  methods: {
   
    hInfo(item) {
      console.log(item);
      this.$router.push(`./antiInfo?ts=${item.msgItems[0].ts}&txid=${item.msgItems[0].txid}`)
    },
    toBlockChain(item) {
      console.log(item);
      this.$router.push(`/Look?ts=${item.msgItems[0].ts}&txid=${item.msgItems[0].txid}`);
    },
  }
}
</script>

<style lang="scss" scoped>
.antiInfo {
  position: relative;
  width: 640px;
  height: 466px;
  background-color: #fff;
  margin-bottom: 20px;
  .aImg { 
 
  width: 100%;
  height: 100%;
  position: relative;
  .info {
    position: absolute;
    top: 24px;
    left: 42px;
    .wen {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 0px;
    color: #000000;
    opacity: 1;
    }
    .tu {
      width: 14px;
      height: 22px;
      margin-left: 14px;
      .img {
        max-height: 21px; 
        max-width: 22px;
      }
    }
  }
.n-info {
  margin-left: 55px;
  .num {
    width: 144px;
    height: 34px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #919AB1;
    opacity: 1;
    margin-bottom: 18px;
    margin-top: -30px;
  }
  .createdDate {
    width: 144px;
    height: 34px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #919AB1;
    opacity: 1;
    margin-bottom: 18px;
  }
  .newDate {
    width: 144px;
    height: 34px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #919AB1;
    opacity: 1;
    
  }
  .n-text {
    width: 260px;
    height: 34px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #000000;
    opacity: 1;
    margin-left: 240px;
  }
}
  .line2 {
    width: 514px;
    height: 0px;
    border: 2px dashed #DBDEE6;
    opacity: 1;
    position: absolute;
    left: 55px;
    top: 280px;
  }
  .line {
    position: absolute;
    width: 344px;
    height: 0px;
    border: 1px solid #68B2A2;;
    opacity: 1;
    left: 42px;
    top: 80px;
  }
  .state {
   
    .bgImg {
      width: 317px;
      height: 160px;
    }
    position: relative;
    display: flex;
    // background-image: url('../assets/images/框\(1\).png');
    position: absolute;
    top: 138px;
    left: 54px;
    // background-color: red;
    background-repeat:no-repeat;
    background-size:100% 100%;
    width: 317px;
    height: 160px;
    .title {
      position: absolute;
      top: 40px;
      left: 38px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #26907A;
      opacity: 1;
      width: 112px;
      height: 40px;
      border-left: 0
    }
    .title2 {
      position: absolute;
      top: 35px;
      right: 54px;
      left: 180px;
      font-size: 48px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #269079;
      opacity: 1;
      width: 96px;
      height: 66px;
    }
      .text1 {
        position: absolute;
        top: 75px;
        left: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 0px;
        color: #fff;
        opacity: 1;
        width: 238px;
        height: 44px;
        background: #96C9BF;
        border-radius: 10px;
      }
      .text2 {
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #fff;
      opacity: 1;
      margin-left: -7px;
      }
    .time {
      position: absolute;
      width: 250px;
      height: 28px;
      left: 47%;
      margin-left: -105px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #9DA5B2;
      opacity: 1;
    }
  }
 }
 .goods-characteristic {
  
  width: 542px;
  //   padding: 48px 20px;
  margin: 0 auto;
  padding-bottom: 20px;
  .goods-characteristic-inner {
    
    // height: 62px;
    margin: 0 auto;
    line-height: 38px;
    padding: 12px 30px;
    font-size: 28px;
    color: #11745f;
    border: 1px solid #11745f;
    border-radius: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.Photo {
  position: relative;
  width: 640px;
  height: 188px;
  
  margin-top: 10px;
  .adv {
    position: absolute;
    width: 66px;
    height: 34px;
    background: #000000;
    opacity: 0.38;
    border-radius: 0px;
    right: 0;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 32px;
    color: #FFFFFF;
    opacity: 1;
    text-align: center;
  }
}
.Photo2 {
  width: 640px;
  height: 188px;
  
  margin-top: 10px;
}
}

</style>